<template>
  <p v-if="formHeader" v-html-sanitize="formHeader" />
</template>

<script>
export default {
  name: "FormViewerHeader",
  props: ["formHeader"]
};
</script>
